import type { OfflineInlineImageRecord } from './offlineInlineImageQueue';

export async function materializeOfflineInlineImage(
  record: OfflineInlineImageRecord,
): Promise<File> {
  const binary = atob(record.dataBase64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }
  return new File([bytes], record.fileName, { type: record.mimeType });
}
